.pageHeading {
  margin-top: 16px;
  padding-left: var(--page-margin);
  padding-right: var(--page-margin);
}

.breadcrumbs {
  margin-top: 0;
  margin-bottom: 8px;
}

@media all and (--reefer-media-tablet-min) {
  .pageHeading {
    margin-top: 24px;
    padding-left: var(--page-margin-desktop);
    padding-right: var(--page-margin-desktop);
  }
}
